// Actions
import {
  AUTH_LOG_USER_IN,
  AUTH_LOG_USER_OUT,
  AUTH_MERGE_USER_DETAILS,
  AUTH_SET_USER_DETAILS,
  AUTH_SET_USER,
} from '../actionTypes';
import { resetNotificationPreferences } from '../app/actions';

/**
 * Logs the user in the store
 * @param payload {user} The user object
 * @returns {function(*): Promise<null>}
 */
export const logUserIn = (payload) => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: AUTH_LOG_USER_IN,
    payload,
  });
  resolve();
});

/**
 * Sets the user details
 * @param payload {userDetails} The user details object
 * @returns {function(*): Promise<null>}
 */
export const setUserDetails = (payload) => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: AUTH_SET_USER_DETAILS,
    payload,
  });
  resolve();
});

/**
 * Merges fields into the user details already in the store
 * @param payload {userDetails} The user details fields to merge
 * @returns {function(*): Promise<null>}
 */
export const mergeUserDetails = (payload) => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: AUTH_MERGE_USER_DETAILS,
    payload,
  });
  resolve();
});

/**
 * Sets the user in the store
 * @param payload {user} The user object
 * @returns {function(*): Promise<null>}
 */
export const setUser = (payload) => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: AUTH_SET_USER,
    payload,
  });
  resolve();
});

/**
 * Logs the user out of the store
 * @returns {function(*): Promise<null>}
 */
export const logUserOut = () => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: AUTH_LOG_USER_OUT,
  });
  dispatch(resetNotificationPreferences());
  resolve();
});
